import {Component, EventEmitter, OnInit, Output, signal} from '@angular/core';
import {RequestService} from "../../../services/api/v1/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomMessageService, UtilService} from "library";
import {SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";


@Component({
  selector: 'app-sales-accept-credit-conditions',
  templateUrl: './sales-accept-credit-conditions.component.html',
  styles: [
  ]
})
export class SalesAcceptCreditConditionsComponent implements OnInit {
  requestId: string;
  flowCode: string;
  request: any
  data = signal<any>({});
  readonly categoryCode = this.route.snapshot.params['category_code'];
  isTopUpLoan: boolean = false;
  @Output() nextStepEvent = new EventEmitter();
  @Output() gotoStepEvent = new EventEmitter();


  constructor(private requestService: RequestService,
              private route: ActivatedRoute,
              private utilService: UtilService,
              private customMessageService: CustomMessageService,
              private salesWorkflowService: SalesWorkflowService) {
    this.requestId = this.route.snapshot.params['request_id'];
    this.flowCode = this.route.snapshot.params['flow_code'];
    this.request = this.requestService.request;
  }

  ngOnInit() {
    this.data.set(this.requestService.request);
    this.isTopUpLoan = this.request.top_up_loan ?? false;
  }

  onNextStep() {
    this.utilService.enablePageLoading();
    this.nextStepEvent.emit();
  }

  onGotoStep(event: {categoryId: string, stepCode: string}) {
    this.utilService.enablePageLoading();
    this.gotoStepEvent.emit(event);
  }

  frequencyText(): string {
    return this.utilService.getFrequencyDescription(this.request.quotes?.frecuency);
  }

  calculateFinancedAmount(): number {
    const price = this.request?.quotes?.prices?.selected || 0;
    const installment = this.request?.quotes?.installment?.selected || 0;
    return price - installment;
  }

  get showChangeProductButton(): boolean {
    const setting = this.salesWorkflowService.currentStep?.setting;
    return !(setting?.hide_change_product_button?.value === true);
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
  protected readonly SalesWorkflow = SalesWorkflow;

}
